import createReducer from '../utils/createReducer';
import actions from '../actions/confirmationPage';
import {MERCHANT_OF_RECORD} from "../utils/constants";

const initialState = {};

const actionHandlers = {
    [actions.SET_BUSINESS_MODEL_SWITCH_CHOICE](state, { payload }) {
        const advertiserBusinessModel = payload.advertiserBusinessModel;
        const preferredBusinessModel = payload.preferredBusinessModel;
        return {
            ...state,
            showBusinessModelSwitch: advertiserBusinessModel === MERCHANT_OF_RECORD.AGENCY
                && preferredBusinessModel !== MERCHANT_OF_RECORD.AGENCY,
        };
    },
};

export default createReducer(actionHandlers, initialState);
